import React, { memo } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { DraggableCore } from 'react-draggable';
import styled from 'styled-components';

const Rect = styled.div`
  cursor: grab;
  background: #eee;
  border: 1px solid ${(p) => p.theme.colors.gray};
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 3px;
  transition: background 200ms;
  z-index: 2;

  &:hover {
    background: ${(p) => p.theme.colors.interaction};
  }
`;

const rectWidth = 16;
const rectHeight = 40;

const Mover = ({ xScale, margin, currData, height, percentile }) => {
  const setIncome = useStoreActions((state) => state.income.setIncome);
  const membersAbove14 = useStoreState((state) => state.income.membersAbove14);
  const membersBelow14 = useStoreState((state) => state.income.membersBelow14);

  const xValue = percentile[config.columns.PERCENTAGE];
  const x = xScale(xValue);

  return (
    <DraggableCore
      onDrag={(evt, dragData) => {
        const perc = Math.round(xScale.invert(dragData.x - margin.left));
        const income =
          currData.data.find((d) => d[config.columns.PERCENTAGE] === perc)[
            config.columns.AVG
          ] *
          (1 + (membersAbove14 - 1) * 0.5 + membersBelow14 * 0.3);

        setIncome(Math.round(income));
      }}
    >
      <Rect
        style={{
          transform: `translate(-50%,${height * 0.5 - rectHeight / 2}px)`,
          left: x + margin.left,
          width: rectWidth,
          height: rectHeight,
        }}
        y={height * 0.5 - rectHeight / 2}
        className="mover"
      />
    </DraggableCore>
  );
};

export default memo(Mover);
